import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentFenceGroupDetails } from 'state/fence/fenceSelector';
import FenceElements from '../FenceElements/FenceElements';
import style from './FenceCanvasBody.module.scss';

const FenceCanvasHeader = ({ onOpenAddElementModal }) => {
  const fence = useSelector((state) => state.fence);
  const currentFenceGroupDetails = useSelector(getCurrentFenceGroupDetails);
  const fenceGroup = fence.groups[0];

  const noElementsAdded = useMemo(
    () => fenceGroup.settings.readyToDesign && fenceGroup.elements.length === 0,
    [fenceGroup.settings.readyToDesign, fenceGroup.elements.length]
  );

  return (
    <div className={style.canvasBody}>
      <FenceElements fence={fence} fenceGroupDetails={currentFenceGroupDetails} editable />

      <button
        type="button"
        className={style.canvasBody_btn}
        onClick={() => onOpenAddElementModal()}
        title="Új elem hozzáadása"
      >
        <i className="material-symbols-outlined">add</i>
      </button>

      {noElementsAdded && <div className={style.canvasBody_alert}>A tervezés megkezdéséhez nyomd meg a + gombot!</div>}
    </div>
  );
};

export default FenceCanvasHeader;
